import styled from 'styled-components';

import { ActionInput } from '@dreryk/react-components';

export const StyledActionInput = styled(ActionInput)`
   width: 480px;
`;

StyledActionInput.displayName = 'StyledActionInput';
